var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiProperty, ApiPropertyOptional, IntersectionType, OmitType, PartialType, PickType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsNumber, IsObject, IsOptional, IsString, ValidateNested, IsArray } from "class-validator";
import { AccessRecord } from "./access.ledger.dtos";
import { ConsentDataResourceScope, ConsentDataSensitivityScope } from "./consentscopes.dtos";
import { ExternalResearcherOrganizationDto, ExternalResearcherOrganizationPublicProfileDto } from "./externalresearcherorganization.dtos";
import { ExternalResearcherUserDto } from "./externalresearcherorganizationuser.dtos";
import { HealthcareOrganizationDto, HealthcareOrganizationPublicProfileDto } from "./healthcareorganization.dtos";
import { HealthcareOrganizationUserDto } from "./healthcareorganizationuser.dtos";
import { TranscodeDto } from "./transcode.dtos";
import { TransformDateOnly } from "./transformers";
import { UserType } from "./user.dtos";
import { CompositeUpdatedAtDto } from "./compositeUpdateAt.dto";
import { PreviewScreenshot } from "./screenshot.dtos";
import { StudyTranslationLanguage } from "./study-translation-language.dtos";
import { ProjectSectionName } from "./project.data.dtos";
export var StudyVersionStatus;
(function (StudyVersionStatus) {
    StudyVersionStatus["DRAFT"] = "DRAFT";
    StudyVersionStatus["ACTIVE"] = "ACTIVE";
})(StudyVersionStatus || (StudyVersionStatus = {}));
export var ProjectType;
(function (ProjectType) {
    ProjectType["GENERAL_DATA_USE"] = "GENERAL_DATA_USE";
    ProjectType["AI_DATA_USE"] = "AI_DATA_USE";
})(ProjectType || (ProjectType = {}));
export var StudyType;
(function (StudyType) {
    StudyType["INTERVENTIONAL"] = "INTERVENTIONAL";
    StudyType["REGISTRY"] = "REGISTRY";
    StudyType["OTHER"] = "OTHER";
})(StudyType || (StudyType = {}));
export { StudyTranslationLanguage };
export var StudyInvestigationType;
(function (StudyInvestigationType) {
    StudyInvestigationType["IND"] = "IND";
    StudyInvestigationType["IDE"] = "IDE";
    StudyInvestigationType["NEITHER"] = "NEITHER";
})(StudyInvestigationType || (StudyInvestigationType = {}));
export var StudyPeriodicUnit;
(function (StudyPeriodicUnit) {
    StudyPeriodicUnit["DAY"] = "DAY";
    StudyPeriodicUnit["WEEK"] = "WEEK";
    StudyPeriodicUnit["MONTH"] = "MONTH";
})(StudyPeriodicUnit || (StudyPeriodicUnit = {}));
export var StudyPeriodicDayAndWeekUnits;
(function (StudyPeriodicDayAndWeekUnits) {
    StudyPeriodicDayAndWeekUnits["DAY"] = "DAY";
    StudyPeriodicDayAndWeekUnits["WEEK"] = "WEEK";
})(StudyPeriodicDayAndWeekUnits || (StudyPeriodicDayAndWeekUnits = {}));
export var StudySectionType;
(function (StudySectionType) {
    StudySectionType["REGULAR"] = "REGULAR";
    StudySectionType["DRAFT"] = "DRAFT";
    StudySectionType["UNPLACED"] = "UNPLACED";
})(StudySectionType || (StudySectionType = {}));
export var StudySectionImageStatus;
(function (StudySectionImageStatus) {
    StudySectionImageStatus["ACTIVE"] = "ACTIVE";
    StudySectionImageStatus["PENDING"] = "PENDING";
    StudySectionImageStatus["DRAFT"] = "DRAFT";
})(StudySectionImageStatus || (StudySectionImageStatus = {}));
export var StudyImageSectionName;
(function (StudyImageSectionName) {
    StudyImageSectionName["STUDY_INFORMATION"] = "STUDY_INFORMATION";
    StudyImageSectionName["PURPOSE_OF_RESEARCH"] = "PURPOSE_OF_RESEARCH";
    StudyImageSectionName["STUDY_LENGTH_AND_NUMBER_OF_PARTICIPANTS"] = "STUDY_LENGTH_AND_NUMBER_OF_PARTICIPANTS";
    StudyImageSectionName["PROCEDURES_AND_INTERVENTIONS"] = "PROCEDURES_AND_INTERVENTIONS";
    StudyImageSectionName["TIMELINE_FOR_VISITS_AND_INTERVENTIONS"] = "TIMELINE_FOR_VISITS_AND_INTERVENTIONS";
    StudyImageSectionName["STUDY_RISKS"] = "STUDY_RISKS";
    StudyImageSectionName["STUDY_BENEFITS"] = "STUDY_BENEFITS";
    StudyImageSectionName["VOLUNTARY_PARTICIPATION_AND_ALTERNATIVES"] = "VOLUNTARY_PARTICIPATION_AND_ALTERNATIVES";
    StudyImageSectionName["WITHDRAWAL_IMPLICATIONS"] = "WITHDRAWAL_IMPLICATIONS";
    StudyImageSectionName["INJURY_PROTOCOL"] = "INJURY_PROTOCOL";
    StudyImageSectionName["PARTICIPATION_TERMINATION"] = "PARTICIPATION_TERMINATION";
    StudyImageSectionName["FUTURE_DATA_USE"] = "FUTURE_DATA_USE";
    StudyImageSectionName["CONFIDENTIALITY_MEASURES"] = "CONFIDENTIALITY_MEASURES";
    StudyImageSectionName["COMPENSATION"] = "COMPENSATION";
    StudyImageSectionName["COST_OF_PARTICIPATION"] = "COST_OF_PARTICIPATION";
    StudyImageSectionName["RESEARCH_RESULTS"] = "RESEARCH_RESULTS";
    StudyImageSectionName["WHO_TO_CONTACT"] = "WHO_TO_CONTACT";
    StudyImageSectionName["ADDITIONAL_SECTION"] = "ADDITIONAL_SECTION";
})(StudyImageSectionName || (StudyImageSectionName = {}));
export var AddStudySection;
(function (AddStudySection) {
    AddStudySection["LOGIN"] = "LOGIN";
    AddStudySection["ENROLLMENT_WELCOME"] = "ENROLLMENT_WELCOME";
    AddStudySection["CALIFORNIA_BILL_OF_RIGHTS"] = "CALIFORNIA_BILL_OF_RIGHTS";
    AddStudySection["STUDY_INFORMATION"] = "STUDY_INFORMATION";
    AddStudySection["PURPOSE_OF_RESEARCH"] = "PURPOSE_OF_RESEARCH";
    AddStudySection["LENGTH_OF_STUDY"] = "LENGTH_OF_STUDY";
    AddStudySection["HEALTH_RECORD_UPDATES"] = "HEALTH_RECORD_UPDATES";
    AddStudySection["PROCEDURES_AND_INTERVENTIONS"] = "PROCEDURES_AND_INTERVENTIONS";
    AddStudySection["TIMELINE"] = "TIMELINE";
    AddStudySection["STUDY_RISKS"] = "STUDY_RISKS";
    AddStudySection["STUDY_BENEFITS"] = "STUDY_BENEFITS";
    AddStudySection["VOLUNTARY_PARTICIPATION"] = "VOLUNTARY_PARTICIPATION";
    AddStudySection["WITHDRAWAL_IMPLICATIONS"] = "WITHDRAWAL_IMPLICATIONS";
    AddStudySection["INJURY_PROTOCOL"] = "INJURY_PROTOCOL";
    AddStudySection["PARTICIPATION_TERMINATION"] = "PARTICIPATION_TERMINATION";
    AddStudySection["DATA_TYPES"] = "DATA_TYPES";
    AddStudySection["FUTURE_DATA_USE"] = "FUTURE_DATA_USE";
    AddStudySection["CONFIDENTIALITY_MEASURES"] = "CONFIDENTIALITY_MEASURES";
    AddStudySection["PATIENT_COMPENSATION"] = "PATIENT_COMPENSATION";
    AddStudySection["COST_OF_PARTICIPATION"] = "COST_OF_PARTICIPATION";
    AddStudySection["RESEARCH_RESULTS"] = "RESEARCH_RESULTS";
    AddStudySection["WHO_TO_CONTACT"] = "WHO_TO_CONTACT";
    AddStudySection["ADDITIONAL_SECTIONS_1"] = "ADDITIONAL_SECTIONS_1";
    AddStudySection["ADDITIONAL_SECTIONS_2"] = "ADDITIONAL_SECTIONS_2";
    AddStudySection["ADDITIONAL_SECTIONS_3"] = "ADDITIONAL_SECTIONS_3";
    AddStudySection["ADDITIONAL_SECTIONS_4"] = "ADDITIONAL_SECTIONS_4";
    AddStudySection["ADDITIONAL_SECTIONS_5"] = "ADDITIONAL_SECTIONS_5";
    AddStudySection["ADDITIONAL_SECTIONS_6"] = "ADDITIONAL_SECTIONS_6";
    AddStudySection["ADDITIONAL_SECTIONS_7"] = "ADDITIONAL_SECTIONS_7";
    AddStudySection["ADDITIONAL_SECTIONS_8"] = "ADDITIONAL_SECTIONS_8";
    AddStudySection["ADDITIONAL_SECTIONS_9"] = "ADDITIONAL_SECTIONS_9";
    AddStudySection["ADDITIONAL_SECTIONS_10"] = "ADDITIONAL_SECTIONS_10";
    AddStudySection["ENROLLEMNT_INFORMED_CONSENT_DECISION"] = "ENROLLEMNT_INFORMED_CONSENT_DECISION";
    AddStudySection["HIPAA_AUTHORIZATION"] = "HIPAA_AUTHORIZATION";
    AddStudySection["PARTICIPANT_CONSENT"] = "PARTICIPANT_CONSENT";
    AddStudySection["MINOR_PARTICIPANT_CONSENT"] = "MINOR_PARTICIPANT_CONSENT";
    AddStudySection["WITNESS_SIGNATURE"] = "WITNESS_SIGNATURE";
    AddStudySection["PROVIDER_SIGNATURE"] = "PROVIDER_SIGNATURE";
    AddStudySection["ENROLLMENT_CONSENT_CONFIRMATION"] = "ENROLLMENT_CONSENT_CONFIRMATION";
    AddStudySection["DECLINE_ENROLLMENT_CONFIRMATION"] = "DECLINE_ENROLLMENT_CONFIRMATION";
    AddStudySection["NEEDS_FOLLOW_UP"] = "NEEDS_FOLLOW_UP";
})(AddStudySection || (AddStudySection = {}));
export const StudyImageSectionNameLabels = {
    [StudyImageSectionName.STUDY_INFORMATION]: "Study information",
    [StudyImageSectionName.PURPOSE_OF_RESEARCH]: "Purpose of research",
    [StudyImageSectionName.STUDY_LENGTH_AND_NUMBER_OF_PARTICIPANTS]: "Study length and number of participants",
    [StudyImageSectionName.PROCEDURES_AND_INTERVENTIONS]: "Procedures and interventions",
    [StudyImageSectionName.TIMELINE_FOR_VISITS_AND_INTERVENTIONS]: "Timeline for visits and interventions",
    [StudyImageSectionName.STUDY_RISKS]: "Study risks",
    [StudyImageSectionName.STUDY_BENEFITS]: "Study benefits",
    [StudyImageSectionName.VOLUNTARY_PARTICIPATION_AND_ALTERNATIVES]: "Voluntary participation and alternatives",
    [StudyImageSectionName.WITHDRAWAL_IMPLICATIONS]: "Withdrawal implications",
    [StudyImageSectionName.INJURY_PROTOCOL]: "Injury protocol",
    [StudyImageSectionName.PARTICIPATION_TERMINATION]: "Participation termination",
    [StudyImageSectionName.FUTURE_DATA_USE]: "Future data use",
    [StudyImageSectionName.CONFIDENTIALITY_MEASURES]: "Confidentiality measures",
    [StudyImageSectionName.COMPENSATION]: "Patient compensation",
    [StudyImageSectionName.COST_OF_PARTICIPATION]: "Cost of participation",
    [StudyImageSectionName.RESEARCH_RESULTS]: "Research results",
    [StudyImageSectionName.WHO_TO_CONTACT]: "Who to contact",
    [StudyImageSectionName.ADDITIONAL_SECTION]: "Additional section",
    [ProjectSectionName.OVERVIEW]: "Overview",
    [ProjectSectionName.KEY_RESOURCES]: "Key resources",
    [ProjectSectionName.STUDY_SETTINGS]: "Study settings",
    [ProjectSectionName.PATIENT_OUTREACH_SETTINGS]: "Patient outreach settings",
    [ProjectSectionName.HEALTH_RECORD_UPDATE_SETTINGS]: "Health record update settings",
    [ProjectSectionName.LOGIN]: "Login",
    [ProjectSectionName.WELCOME]: "Welcome",
    [ProjectSectionName.HEALTH_RECORD_EXPLANATION]: "Health record explanation",
    [ProjectSectionName.RECIPIENTS_AND_THIRD_PARTIES]: "Recipients and third parties",
    [ProjectSectionName.PURPOSE_OF_DATA_ACCESS_AND_USE]: "Purpose of data access and use",
    [ProjectSectionName.STATESPECIFIC_REQUIREMENTS]: "State-specific requirements",
    [ProjectSectionName.INTRODUCTION]: "Introduction",
    [ProjectSectionName.PARTICIPATION_ACTIVITIES_AND_PROCEDURES]: "Participation activities and procedures",
    [ProjectSectionName.PATIENT_COMPENSATION]: "Patient compensation",
    [ProjectSectionName.HEALTH_RECORD_SOURCE_AND_SCOPE]: "Health record source and scope",
    [ProjectSectionName.VOLUNTARY_HEALTH_RECORD_USE]: "Voluntary health record use",
    [ProjectSectionName.CONSENT_EXPIRATION_AND_REVOCATION]: "Consent expiration and revocation",
    [ProjectSectionName.FUTURE_USE_OF_HEALTH_RECORDS]: "Future use of health records",
    [ProjectSectionName.PATIENT_HEALTH_RECORD_RIGHTS]: "Patient health record rights",
    [ProjectSectionName.HEALTH_RECORD_UPDATES]: "Health record updates",
    [ProjectSectionName.CONFIDENTALITY_MEASURES]: "Confidentiality measures",
    [ProjectSectionName.ADDITIONAL_INFORMATION]: "Additional information",
    [ProjectSectionName.ADDITIONAL_INFORMATION_1]: "Additional information #1",
    [ProjectSectionName.ADDITIONAL_INFORMATION_2]: "Additional information #2",
    [ProjectSectionName.ADDITIONAL_INFORMATION_3]: "Additional information #3",
    [ProjectSectionName.ADDITIONAL_INFORMATION_4]: "Additional information #4",
    [ProjectSectionName.ADDITIONAL_INFORMATION_5]: "Additional information #5",
    [ProjectSectionName.ADDITIONAL_INFORMATION_6]: "Additional information #6",
    [ProjectSectionName.ADDITIONAL_INFORMATION_7]: "Additional information #7",
    [ProjectSectionName.ADDITIONAL_INFORMATION_8]: "Additional information #8",
    [ProjectSectionName.ADDITIONAL_INFORMATION_9]: "Additional information #9",
    [ProjectSectionName.ADDITIONAL_INFORMATION_10]: "Additional information #10",
    [ProjectSectionName.PATIENT_CONSENT]: "Patient consent",
    [ProjectSectionName.PATIENT_SIGNATURE]: "Patient signature",
    [ProjectSectionName.PARENTGUARDIAN_SIGNATURE]: "Parent/guardian signature",
    [ProjectSectionName.WITNESS_SIGNATURE]: "Witness signature",
    [ProjectSectionName.CONSENT_FACILITATOR_SIGNATURE]: "Consent facilitator signature",
    [ProjectSectionName.CONSENT_CONFIRMATION]: "Consent confirmation",
    [ProjectSectionName.DECLINE_CONSENT_CONFIRMATION]: "Decline consent confirmation",
    [ProjectSectionName.NEEDS_FOLLOWUP_CONFIRMATION]: "Needs follow-up confirmation",
    [ProjectSectionName.ABOUT_THE_PROJECT]: "About the project",
    [ProjectSectionName.PATIENT_RECORD_RETRIEVAL_RECENCY]: "Patient record retrieval recency",
    [ProjectSectionName.REQUEST_DETAILS]: "Request details",
    [ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS]: "Frequently asked questions",
    [ProjectSectionName.CONFIRM_ACCESS]: "Confirm access",
    [ProjectSectionName.CONFIRMATION_OF_RECORDS_SHARED]: "Confirmation of records shared",
    [ProjectSectionName.CONFIRMATION_OF_DECLINE]: "Confirmation of decline",
};
export var StudyPatientConsentStatusSearch;
(function (StudyPatientConsentStatusSearch) {
    StudyPatientConsentStatusSearch["OPTED_IN"] = "OPTED_IN";
    StudyPatientConsentStatusSearch["OPTED_OUT"] = "OPTED_OUT";
    StudyPatientConsentStatusSearch["INCLUDE_ALL_OPTED_IN"] = "INCLUDE_ALL_OPTED_IN";
})(StudyPatientConsentStatusSearch || (StudyPatientConsentStatusSearch = {}));
const AllProjectSectionImageNames = { ...StudyImageSectionName, ...ProjectSectionName };
const AllProjectSections = { ...AddStudySection, ...ProjectSectionName };
export class StudySectionImageDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudySectionImageDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudySectionImageDto.prototype, "imageUrl", void 0);
__decorate([
    IsEnum(AllProjectSectionImageNames),
    __metadata("design:type", String)
], StudySectionImageDto.prototype, "sectionName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudySectionImageDto.prototype, "status", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudySectionImageDto.prototype, "order", void 0);
__decorate([
    IsEnum(StudySectionType),
    __metadata("design:type", String)
], StudySectionImageDto.prototype, "sectionType", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudySectionImageDto.prototype, "caption", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudySectionImageDto.prototype, "icfTextSegmentId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudySectionImageDto.prototype, "additionalSectionId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudySectionImageDto.prototype, "translatedFrom", void 0);
__decorate([
    IsString(),
    IsEnum(StudyTranslationLanguage),
    __metadata("design:type", String)
], StudySectionImageDto.prototype, "language", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Date)
], StudySectionImageDto.prototype, "updatedAt", void 0);
export class StudySectionImageAIDto {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudySectionImageAIDto.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudySectionImageAIDto.prototype, "imageUrl", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudySectionImageAIDto.prototype, "caption", void 0);
export class StudySectionImagePreviewInput extends StudySectionImageDto {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudySectionImagePreviewInput.prototype, "filename", void 0);
export class CreateStudySectionImageInput extends OmitType(StudySectionImageDto, ["id"]) {
}
export class CreateStudySectionImageBatchInput {
}
__decorate([
    ApiProperty({
        isArray: true,
        type: () => CreateStudySectionImageInput,
    }),
    IsObject({ each: true }),
    __metadata("design:type", Array)
], CreateStudySectionImageBatchInput.prototype, "images", void 0);
export class UpdateStudySectionImageBatchInput {
}
__decorate([
    ApiProperty({
        isArray: true,
        type: () => UpdateStudySectionImageInput,
    }),
    IsObject({ each: true }),
    __metadata("design:type", Array)
], UpdateStudySectionImageBatchInput.prototype, "images", void 0);
export class MoveStudySectionImageInput extends PickType(StudySectionImageDto, ["sectionType", "sectionName", "additionalSectionId"]) {
}
export class CopyStudySectionImageInput extends PickType(StudySectionImageDto, ["sectionType", "sectionName", "additionalSectionId"]) {
}
export const StudyInvestigationTypeDisplayNames = {
    [StudyInvestigationType.IND]: "Investigational New Drug (IND)",
    [StudyInvestigationType.IDE]: "Investigational Device Exemption (IDE)",
    [StudyInvestigationType.NEITHER]: "Neither",
};
export const MIN_STUDY_SEARCH_LENGTH = 3;
export const sectionDisplayNames = {
    contactInformation: "Contact Information",
    sensitiveData: "Sensitive Data",
    billOfPatientRights: "Bill of Patient Rights",
    signatures: "Signatures",
};
export const sectionKeys = Object.keys(sectionDisplayNames);
export class StudyAdditionalSectionDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyAdditionalSectionDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyAdditionalSectionDto.prototype, "title", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyAdditionalSectionDto.prototype, "description", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], StudyAdditionalSectionDto.prototype, "included", void 0);
__decorate([
    IsString(),
    IsEnum(StudyTranslationLanguage),
    __metadata("design:type", String)
], StudyAdditionalSectionDto.prototype, "language", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyAdditionalSectionDto.prototype, "translatedFrom", void 0);
__decorate([
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], StudyAdditionalSectionDto.prototype, "updatedAt", void 0);
__decorate([
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], StudyAdditionalSectionDto.prototype, "updatedTitleAt", void 0);
__decorate([
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], StudyAdditionalSectionDto.prototype, "updatedDescriptionAt", void 0);
export class StudyAdditionalSectionInputForTranslation extends OmitType(StudyAdditionalSectionDto, [
    "language",
    "included",
    "updatedAt",
    "updatedTitleAt",
    "updatedDescriptionAt",
]) {
}
export class StudyAdditionalSectionResponse extends OmitType(StudyAdditionalSectionDto, ["language", "included", "id"]) {
}
export class CreateStudyAdditionalSectionInput extends OmitType(StudyAdditionalSectionDto, [
    "id",
    "updatedAt",
    "updatedTitleAt",
    "updatedDescriptionAt",
]) {
}
export class UpdateStudyAdditionalSectionInputBaseAdditionalSection extends PartialType(StudyAdditionalSectionDto) {
}
export class UpdateStudyAdditionalSectionInputBaseSectionImage extends PartialType(StudySectionImageDto) {
}
export class UpdateStudyAdditionalSectionInput extends PartialType(StudyAdditionalSectionDto) {
}
__decorate([
    Type(() => UpdateStudyAdditionalSectionInputBaseAdditionalSection),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", UpdateStudyAdditionalSectionInputBaseAdditionalSection)
], UpdateStudyAdditionalSectionInput.prototype, "baseAdditionalSection", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateStudyAdditionalSectionInput.prototype, "delete", void 0);
export class StudyAdditionalSectionConflictErrorDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => UpdateStudyAdditionalSectionInputBaseAdditionalSection),
    ValidateNested(),
    __metadata("design:type", UpdateStudyAdditionalSectionInputBaseAdditionalSection)
], StudyAdditionalSectionConflictErrorDto.prototype, "conflicts", void 0);
export class UpdateStudySectionImageInput extends PartialType(StudySectionImageDto) {
}
__decorate([
    Type(() => UpdateStudyAdditionalSectionInputBaseSectionImage),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", UpdateStudyAdditionalSectionInputBaseSectionImage)
], UpdateStudySectionImageInput.prototype, "baseSectionImage", void 0);
export class StudySectionImageConflictErrorDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => UpdateStudyAdditionalSectionInputBaseSectionImage),
    ValidateNested(),
    __metadata("design:type", UpdateStudyAdditionalSectionInputBaseSectionImage)
], StudySectionImageConflictErrorDto.prototype, "conflicts", void 0);
export class StudyTimelineVisitsDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyTimelineVisitsDto.prototype, "period", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyTimelineVisitsDto.prototype, "description", void 0);
export var SegmentType;
(function (SegmentType) {
    SegmentType["TEXT"] = "TEXT";
    SegmentType["IMAGE"] = "IMAGE";
})(SegmentType || (SegmentType = {}));
export var SegmentStatus;
(function (SegmentStatus) {
    SegmentStatus["DRAFT"] = "DRAFT";
    SegmentStatus["ACTIVE"] = "ACTIVE";
})(SegmentStatus || (SegmentStatus = {}));
export class StudyICFTextSegmentDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyICFTextSegmentDto.prototype, "id", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], StudyICFTextSegmentDto.prototype, "reviewed", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyICFTextSegmentDto.prototype, "precedingText", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyICFTextSegmentDto.prototype, "unplacedText", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyICFTextSegmentDto.prototype, "succeedingText", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyICFTextSegmentDto.prototype, "order", void 0);
__decorate([
    IsEnum(SegmentType),
    __metadata("design:type", String)
], StudyICFTextSegmentDto.prototype, "segmentType", void 0);
__decorate([
    IsEnum(SegmentStatus),
    __metadata("design:type", String)
], StudyICFTextSegmentDto.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudyICFTextSegmentDto.prototype, "caption", void 0);
export class CreateStudyICFTextSegmentInput extends OmitType(StudyICFTextSegmentDto, ["id"]) {
}
export class UpdateStudyICFTextSegmentInput extends PickType(StudyICFTextSegmentDto, ["reviewed"]) {
}
export const DB_STUDY_TYPES = {
    0: StudyType.INTERVENTIONAL,
    1: StudyType.REGISTRY,
    2: StudyType.OTHER,
};
export const BLOCKCHAIN_STUDY_TYPES = {
    INTERVENTIONAL: 0,
    REGISTRY: 1,
    OTHER: 2,
};
export var StudyAccessData;
(function (StudyAccessData) {
    StudyAccessData["FULL_RECORD_IDENTIFIED"] = "FULL_RECORD_IDENTIFIED";
    StudyAccessData["FULL_RECORD_DEIDENTIFIED"] = "FULL_RECORD_DEIDENTIFIED";
})(StudyAccessData || (StudyAccessData = {}));
export const DB_STUDY_ACCESS_DATA = {
    0: StudyAccessData.FULL_RECORD_IDENTIFIED,
    1: StudyAccessData.FULL_RECORD_DEIDENTIFIED,
};
export const BLOCKCHAIN_STUDY_ACCESS_DATA = {
    FULL_RECORD_IDENTIFIED: 0,
    FULL_RECORD_DEIDENTIFIED: 1,
};
export var StudyStatus;
(function (StudyStatus) {
    StudyStatus["DRAFT"] = "DRAFT";
    StudyStatus["ACTIVE"] = "ACTIVE";
    StudyStatus["COMPLETED"] = "COMPLETED";
    StudyStatus["WITHDRAWN"] = "WITHDRAWN";
})(StudyStatus || (StudyStatus = {}));
export const StudyStatusFrom = {
    DRAFT: null,
    ACTIVE: [StudyStatus.DRAFT],
    COMPLETED: [StudyStatus.ACTIVE],
    WITHDRAWN: [StudyStatus.ACTIVE],
};
export function validStudyStatusTransition(from, to) {
    const validFrom = StudyStatusFrom[to];
    if (!validFrom || !from)
        return from === validFrom;
    return validFrom.includes(from);
}
export function isAiOrGeneralDataUse(projectType) {
    if (!projectType)
        return false;
    return [ProjectType.GENERAL_DATA_USE, ProjectType.AI_DATA_USE].includes(projectType);
}
export var StudyParticipationType;
(function (StudyParticipationType) {
    StudyParticipationType["ENROLLMENT"] = "ENROLLMENT";
    StudyParticipationType["PRESCREENING"] = "PRESCREENING";
    StudyParticipationType["DEIDENTIFIED"] = "DEIDENTIFIED";
})(StudyParticipationType || (StudyParticipationType = {}));
export var StudyImportMethod;
(function (StudyImportMethod) {
    StudyImportMethod["CLINICAL_TRIALS"] = "CLINICAL_TRIALS";
    StudyImportMethod["PROTOCOL_DOCUMENT"] = "PROTOCOL_DOCUMENT";
    StudyImportMethod["MANUAL"] = "MANUAL";
})(StudyImportMethod || (StudyImportMethod = {}));
export var ProtocolType;
(function (ProtocolType) {
    ProtocolType["STUDY_PROTOCOLS"] = "studyProtocols";
    ProtocolType["ICF_PROTOCOLS"] = "iCFProtocols";
})(ProtocolType || (ProtocolType = {}));
export var PatientImportMethod;
(function (PatientImportMethod) {
    PatientImportMethod["MANUAL"] = "MANUAL";
    PatientImportMethod["FILE"] = "FILE";
    PatientImportMethod["QR_CODE"] = "QR_CODE";
})(PatientImportMethod || (PatientImportMethod = {}));
export var PatientNotificationType;
(function (PatientNotificationType) {
    PatientNotificationType["ENROLLMENT_REQUESTED"] = "ENROLLMENT_REQUEST";
})(PatientNotificationType || (PatientNotificationType = {}));
export const StudyImportMethodDisplayNames = {
    [StudyImportMethod.CLINICAL_TRIALS]: "ClinicalTrials.gov",
    [StudyImportMethod.PROTOCOL_DOCUMENT]: "Study Protocol document",
    [StudyImportMethod.MANUAL]: "Manual Entry",
};
export var ICFImportMethod;
(function (ICFImportMethod) {
    ICFImportMethod["PROTOCOL_DOCUMENT"] = "PROTOCOL_DOCUMENT";
    ICFImportMethod["AI_GENERATION"] = "AI_GENERATION";
    ICFImportMethod["MANUAL"] = "MANUAL";
    ICFImportMethod["AI_REGENERATION"] = "AI_REGENERATION";
    ICFImportMethod["RETAIN_AI_GENERATIONS"] = "RETAIN_AI_GENERATIONS";
})(ICFImportMethod || (ICFImportMethod = {}));
export const projectRequirementsFields = [
    "studyType",
    "accessData",
    "isSponsor",
    "hipaaOrganizationLegalName",
    "hipaaOrganizationLegalNameConfirmed",
    "projectType",
];
export class CoreStudyDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty(),
    IsString(),
    __metadata("design:type", String)
], CoreStudyDto.prototype, "id", void 0);
__decorate([
    ApiProperty(),
    Type(() => Object, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: HealthcareOrganizationDto, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: ExternalResearcherOrganizationDto, name: UserType.EXTERNAL_RESEARCHER },
            ],
        },
    }),
    ValidateNested(),
    __metadata("design:type", Object)
], CoreStudyDto.prototype, "addedByOrganization", void 0);
__decorate([
    ApiProperty(),
    Type(() => Object, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: HealthcareOrganizationUserDto, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: ExternalResearcherUserDto, name: UserType.EXTERNAL_RESEARCHER },
            ],
        },
    }),
    ValidateNested(),
    __metadata("design:type", Object)
], CoreStudyDto.prototype, "owner", void 0);
__decorate([
    ApiProperty({ enum: StudyStatus, enumName: "StudyStatus" }),
    IsEnum(StudyStatus),
    __metadata("design:type", String)
], CoreStudyDto.prototype, "status", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Object)
], CoreStudyDto.prototype, "lastActivity", void 0);
__decorate([
    ApiPropertyOptional(),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", Object)
], CoreStudyDto.prototype, "lastActivityUser", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], CoreStudyDto.prototype, "paused", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CoreStudyDto.prototype, "pauseReason", void 0);
export class StudyDerivedDto {
}
__decorate([
    ApiProperty({ isArray: true }),
    Type(() => HealthcareOrganizationDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], StudyDerivedDto.prototype, "accessibleHealthcareOrganizations", void 0);
__decorate([
    ApiProperty(),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], StudyDerivedDto.prototype, "createdAt", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Object)
], StudyDerivedDto.prototype, "lastUpdated", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Object)
], StudyDerivedDto.prototype, "firstActivatedAt", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Object)
], StudyDerivedDto.prototype, "versionLastUpdated", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => StudyICFTextSegmentDto,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], StudyDerivedDto.prototype, "icfTextSegments", void 0);
__decorate([
    ApiProperty(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StudyDerivedDto.prototype, "pdda", void 0);
__decorate([
    ApiProperty(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StudyDerivedDto.prototype, "hasDraftVersion", void 0);
export var StudyTranslationImportType;
(function (StudyTranslationImportType) {
    StudyTranslationImportType["AI_GENERATION"] = "AI_GENERATION";
    StudyTranslationImportType["TRANSLATION_DOCUMENT"] = "TRANSLATION_DOCUMENT";
    StudyTranslationImportType["MANUAL"] = "MANUAL";
})(StudyTranslationImportType || (StudyTranslationImportType = {}));
export class StudyTranslatableFieldsDto {
}
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "loginTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "loginText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "welcomeTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "welcomeText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "dataUpdateWelcomeTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "dataUpdateWelcomeText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "californiaBillOfRightsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "californiaBillOfRightsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "studyInformationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "enrollmentVideo", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "deletePrescreenTranscode", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "deleteEnrollmentTranscode", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "purposeOfResearchTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "lengthOfStudyNumberOfParticipantsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "lengthOfStudyNumberOfParticipantsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "healthRecordUpdatesTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "healthRecordUpdatesText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "proceduresAndInterventionsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "timelineTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "benefitsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "risksTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "voluntaryParticipationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "voluntaryParticipationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "withdrawalImplicationsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "injuryProtocolTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "participationTerminationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "dataTypesTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "sensitiveDataTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "sensitiveDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "futureUseOfDataTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "confidentialityMeasuresTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "compensationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "costTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "researchResultsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "whoToContactTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "whoToContactText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "informedConsentTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "informedConsentText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "informedConsentYesText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "informedConsentNoText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "informedConsentInterestedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "hipaaTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "hipaaText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "hipaaOrganizationLegalName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "thankYouConsentedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "thankYouConsentedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "dataUpdateThankYouConsentedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "dataUpdateThankYouConsentedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "thankYouDeclinedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "thankYouDeclinedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "thankYouImInterestedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "thankYouImInterestedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "parentGuardianTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "parentGuardianInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "parentGuardianSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "parentGuardianInformedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "additionalParentGuardianTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "additionalParentGuardianInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "additionalParentGuardianExemptSignatureText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "additionalParentGuardianSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "additionalParentGuardianInformedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "minorParticipantTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "minorParticipantInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "minorParticipantExemptFromAssentText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "minorParticipantAssentTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "minorParticipantAssentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "participantTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "informedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "participantInstructionsForGuidedConsent", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "larTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "larInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "larSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "larInformedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "larParticipantTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "larParticipantInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "larParticipantExemptFromAssentText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "larParticipantAssentTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "larParticipantAssentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "witnessTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "witnessInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "witnessSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "witnessConfirmation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "providerTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "providerInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "providerSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "providerConfirmation", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: String,
    }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyTranslatableFieldsDto.prototype, "informedConsentPrimaryDiseaseOrConditions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "patientFriendlyTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "patientFriendlySummary", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "informedConsentIRBApprovalStamp", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "risksOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "benefitsOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "leavingStudyEarlyText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "injuryProtocolText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "participationTerminationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "futureUseOfData", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "futureUseOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "confidentialityOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "compensationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "costOfParticipationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "sharingResultsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "alternativesToParticipation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "hipaaAuthorizationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "proceduresAndInterventionsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "purposeOfResearchText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "enrollmentTranscodeId", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    Type(() => StudyTimelineVisitsDto),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyTranslatableFieldsDto.prototype, "timelineVisits", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "introTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "introPurposeOfDisclosure", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "introBriefEducation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "patientHealthRecordRightsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "contactDetails", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "purposeOfDataTitle", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyTranslatableFieldsDto.prototype, "purposeOfDataDisclosure", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "purposeOfDataDisclosureOther", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "purposeOfDataBriefEducation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "aiToolName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "aiExplanationOfHealthEx", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "explanationOfDataProtection", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "aiExplanationOfDataUseByLegalOrg", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "aiExplanationOfFees", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "aiAuthToShare", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "aiAuthToShareExplanation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "timeToConnectInformation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "aiToolTermsUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    Type(() => CompositeUpdatedAtDto, {}),
    __metadata("design:type", CompositeUpdatedAtDto)
], StudyTranslatableFieldsDto.prototype, "compositeUpdatedAt", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsDto.prototype, "aiToolIcon", void 0);
export class TranslationsSectionInfoDto {
}
__decorate([
    IsString(),
    IsEnum(AllProjectSections),
    __metadata("design:type", String)
], TranslationsSectionInfoDto.prototype, "section", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], TranslationsSectionInfoDto.prototype, "aiImportUpdatedAt", void 0);
export class StudyTranslatableFieldsWithDefaults extends OmitType(StudyTranslatableFieldsDto, [
    "informedConsentPrimaryDiseaseOrConditions",
    "patientFriendlyTitle",
    "patientFriendlySummary",
    "informedConsentIRBApprovalStamp",
    "risksOfEnrollment",
    "benefitsOfEnrollment",
    "leavingStudyEarlyText",
    "injuryProtocolText",
    "participationTerminationText",
    "futureUseOfData",
    "futureUseOfDataText",
    "confidentialityOfDataText",
    "compensationText",
    "costOfParticipationText",
    "sharingResultsText",
    "hipaaAuthorizationText",
    "proceduresAndInterventionsText",
    "alternativesToParticipation",
    "purposeOfResearchText",
    "timelineVisits",
    "compositeUpdatedAt",
    "introBriefEducation",
    "contactDetails",
    "purposeOfDataTitle",
    "purposeOfDataBriefEducation",
]) {
}
export class StudyTranslatableFieldsWithMetadataDto extends StudyTranslatableFieldsDto {
}
__decorate([
    IsString(),
    IsEnum(StudyTranslationLanguage),
    __metadata("design:type", String)
], StudyTranslatableFieldsWithMetadataDto.prototype, "language", void 0);
__decorate([
    IsString(),
    IsEnum(StudyTranslationImportType),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsWithMetadataDto.prototype, "importType", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsWithMetadataDto.prototype, "enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsWithMetadataDto.prototype, "completed", void 0);
__decorate([
    Type(() => TranslationsSectionInfoDto),
    IsOptional(),
    __metadata("design:type", Array)
], StudyTranslatableFieldsWithMetadataDto.prototype, "sectionInfo", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Object)
], StudyTranslatableFieldsWithMetadataDto.prototype, "importTypeUpdatedAt", void 0);
__decorate([
    IsString(),
    IsEnum(AllProjectSections),
    IsOptional(),
    __metadata("design:type", Object)
], StudyTranslatableFieldsWithMetadataDto.prototype, "section", void 0);
export class StudyVersionDto {
}
__decorate([
    ApiProperty(),
    IsString(),
    __metadata("design:type", String)
], StudyVersionDto.prototype, "studyVersionId", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "versionName", void 0);
__decorate([
    ApiProperty({ enum: StudyVersionStatus, enumName: "StudyVersionStatus" }),
    IsEnum(StudyVersionStatus),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "versionStatus", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "title", void 0);
__decorate([
    ApiProperty({ enum: StudyType, enumName: "StudyType" }),
    IsEnum(StudyType),
    __metadata("design:type", String)
], StudyVersionDto.prototype, "studyType", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "briefSummary", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "studyIdentifier", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "webpageLink", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sponsorOrganizationName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sponsorOrganizationCategory", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "funderType", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "fullRecordWithoutRestrictedData", void 0);
__decorate([
    ApiProperty({ isArray: true }),
    IsEnum(ConsentDataResourceScope, { each: true }),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "consentDataResourceScopes", void 0);
__decorate([
    ApiProperty({ isArray: true }),
    IsEnum(ConsentDataSensitivityScope, { each: true }),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "consentDataSensitivityScopes", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    IsOptional(),
    IsEnum(StudyTranslationLanguage, { each: true }),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "selectedLanguages", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "description", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "clinicalTrialPhase", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: String,
    }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "primaryDiseaseOrConditions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "outcomes", void 0);
__decorate([
    ApiPropertyOptional(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "targetNumberOfPatients", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "inclusionExclusionCriteria", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    TransformDateOnly(),
    IsDate(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "startDate", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    TransformDateOnly(),
    IsDate(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "primaryCompletionDate", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    TransformDateOnly(),
    IsDate(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "completionDate", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sponsorPrimaryContactName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sponsorPrimaryContactTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sponsorPrimaryContactEmail", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sponsorPrimaryContactPhone", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sponsorPrimaryContactPhoneExt", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "investigatorAffiliation", void 0);
__decorate([
    ApiProperty({ enum: StudyAccessData, enumName: "StudyAccessData" }),
    IsEnum(StudyAccessData),
    __metadata("design:type", String)
], StudyVersionDto.prototype, "accessData", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "isSponsor", void 0);
__decorate([
    ApiPropertyOptional({ enumName: "StudyImportMethod" }),
    IsOptional(),
    IsEnum(StudyImportMethod),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "importMethod", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "interventions", void 0);
__decorate([
    Type(() => TranscodeDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "enrollmentTranscode", void 0);
__decorate([
    Type(() => PreviewScreenshot),
    IsOptional(),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "previewScreenshots", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudyVersionDto.prototype, "patientEnrollmentUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sitePrimaryContactName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sitePrimaryContactTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sitePrimaryContactEmail", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sitePrimaryContactPhone", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sitePrimaryContactPhoneExt", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "visitedPages", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "visitedSections", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "protocolNumber", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "require21CFRPart11ForInformedConsents", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "patientFriendlyTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "patientFriendlySummary", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "purposeOfResearchText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "purposeOfResearchEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "risksOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "benefitsOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "proceduresAndInterventionsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "timelineVisitsEnabled", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    Type(() => StudyTimelineVisitsDto),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "timelineVisits", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "alternativeProceduresAndTreatments", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "injuryProtocolText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "leavingStudyEarlyEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "leavingStudyEarlyText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "participationTerminationEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "participationTerminationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "futureUseOfDataEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "futureUseOfData", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "futureUseOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "confidentialityOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "compensation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "compensationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "costOfParticipationEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "costOfParticipationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sharingResultsEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "sharingResultsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "rightToBeContactedByResearcher", void 0);
__decorate([
    ApiPropertyOptional({ enumName: "ICFImportMethod" }),
    IsOptional(),
    IsEnum(ICFImportMethod),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "icfImportMethod", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "icfFileName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "studyProtocolFileName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "lastSkippedGenaiInputHash", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "genaiInputHash", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "hipaaAuthorizationFormUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "hipaaAuthorizationTemplateEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "hipaaAuthorizationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "patientMRNOnInformedConsent", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "orgLogoUrlOnInformedConsent", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => StudyAdditionalSectionDto,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "additionalSections", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => StudySectionImageGroupDto,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "studySectionImages", void 0);
__decorate([
    ApiProperty(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StudyVersionDto.prototype, "informedConsentSectionLocked", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "informedConsentLockSessionId", void 0);
__decorate([
    ApiProperty(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StudyVersionDto.prototype, "isCompletionDateExpired", void 0);
__decorate([
    ApiPropertyOptional({ enum: StudyInvestigationType, enumName: "StudyInvestigationType" }),
    IsEnum(StudyInvestigationType),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "investigationType", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "healthRecordsUpdatesEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "healthRecordsUpdatesOnDemand", void 0);
__decorate([
    ApiPropertyOptional(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "healthRecordsUpdatesEvery", void 0);
__decorate([
    ApiPropertyOptional({ enum: StudyPeriodicDayAndWeekUnits, enumName: "StudyPeriodicDayAndWeekUnits" }),
    IsEnum(StudyPeriodicDayAndWeekUnits),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "healthRecordsUpdatesUnit", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: String,
    }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "informedConsentPrimaryDiseaseOrConditions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "informedConsentIRBApprovalStamp", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    TransformDateOnly(),
    IsDate(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "informedConsentStartDate", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    TransformDateOnly(),
    IsDate(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "informedConsentCompletionDate", void 0);
__decorate([
    ApiPropertyOptional(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "informedTargetNumberOfPatients", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "alternativesToParticipation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], StudyVersionDto.prototype, "informedConsentInterested", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: String,
    }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyVersionDto.prototype, "informedConsentPrimaryDiseaseOrConditionsCopied", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    TransformDateOnly(),
    IsDate(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "informedConsentStartDateCopied", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    TransformDateOnly(),
    IsDate(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "informedConsentCompletionDateCopied", void 0);
__decorate([
    ApiPropertyOptional(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "informedTargetNumberOfPatientsCopied", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "lengthOfStudyEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "informedHealthRecordUpdatesEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "injuryProtocolEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "interventionsEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "confidentialityMeasuresEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], StudyVersionDto.prototype, "hipaaOrganizationLegalNameConfirmed", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "patientMRNOnParticipantSignature", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "minorParticipantConsentEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "additionalParentGuardianEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "additionalParentGuardianExemptSignature", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "minorParticipantExemptFromAssent", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "larConsentEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "larParticipantConsentExemptFromAssent", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "requirementsUpdatedAt", void 0);
__decorate([
    ApiProperty({ enum: ProjectType, enumName: "ProjectType" }),
    IsEnum(ProjectType),
    __metadata("design:type", String)
], StudyVersionDto.prototype, "projectType", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "projectColor", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "projectIcon", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "originalStudyProtocolUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "originalInformedConsentDocumentUrl", void 0);
__decorate([
    ApiProperty(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], StudyVersionDto.prototype, "suppressNotifications", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "organizationIconUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "patientRecordRetrievalRecencyEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "patientRecordRetrievalRecencyEvery", void 0);
__decorate([
    ApiPropertyOptional({ enum: StudyPeriodicUnit, enumName: "StudyPeriodicUnit" }),
    IsEnum(StudyPeriodicUnit),
    IsOptional(),
    __metadata("design:type", Object)
], StudyVersionDto.prototype, "patientRecordRetrievalRecencyUnit", void 0);
export class StudyVersionLiteDto extends IntersectionType(PickType(StudyVersionDto, ["studyVersionId", "versionName", "versionStatus"]), PickType(StudyDerivedDto, ["versionLastUpdated"])) {
}
export class StudyAgentSyncDto {
}
__decorate([
    Type(() => AgentSyncStudyUserDto),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyAgentSyncDto.prototype, "agentSyncStudyUsers", void 0);
export class StudySectionImageGroupDto {
    constructor(partial) {
        Object.assign(this, partial);
    }
}
__decorate([
    IsEnum(StudyImageSectionName),
    __metadata("design:type", String)
], StudySectionImageGroupDto.prototype, "sectionName", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => StudySectionImageDto),
    __metadata("design:type", Array)
], StudySectionImageGroupDto.prototype, "images", void 0);
export class StudyDto extends IntersectionType(CoreStudyDto, StudyVersionDto, StudyTranslatableFieldsDto, StudyDerivedDto, StudyAgentSyncDto) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => StudyTranslatableFieldsWithMetadataDto),
    __metadata("design:type", Array)
], StudyDto.prototype, "studyTranslatableFields", void 0);
export const STUDY_PUBLIC_INFO_TRANSLATABLE_KEYS = [
    "loginTitle",
    "loginText",
    "patientFriendlyTitle",
    "patientFriendlySummary",
    "thankYouDeclinedTitle",
    "thankYouDeclinedText",
    "purposeOfDataTitle",
    "purposeOfDataDisclosure",
    "purposeOfDataDisclosureOther",
    "purposeOfDataBriefEducation",
    "healthRecordUpdatesTitle",
    "healthRecordUpdatesText",
    "whoToContactTitle",
    "whoToContactText",
    "contactDetails",
    "welcomeText",
    "welcomeTitle",
    "dataUpdateWelcomeText",
    "dataUpdateWelcomeTitle",
    "aiToolName",
    "aiExplanationOfHealthEx",
    "explanationOfDataProtection",
    "aiExplanationOfDataUseByLegalOrg",
    "aiExplanationOfFees",
    "aiAuthToShare",
    "aiAuthToShareExplanation",
    "timeToConnectInformation",
    "aiToolTermsUrl",
    "aiToolIcon",
];
export const STUDY_PUBLIC_INFO_KEYS = [
    ...STUDY_PUBLIC_INFO_TRANSLATABLE_KEYS,
    "id",
    "studyVersionId",
    "projectType",
    "pdda",
    "sponsorOrganizationName",
    "organizationIconUrl",
    "selectedLanguages",
    "sitePrimaryContactName",
    "sitePrimaryContactTitle",
    "sitePrimaryContactEmail",
    "sitePrimaryContactPhone",
    "sitePrimaryContactPhoneExt",
    "healthRecordsUpdatesEnabled",
    "healthRecordsUpdatesOnDemand",
    "healthRecordsUpdatesEvery",
    "healthRecordsUpdatesUnit",
    "hipaaOrganizationLegalName",
    "studySectionImages",
    "status",
    "isCompletionDateExpired",
    "patientRecordRetrievalRecencyEnabled",
    "patientRecordRetrievalRecencyEvery",
    "patientRecordRetrievalRecencyUnit",
];
export class StudyPublicInfoAdditionalSectionDto extends PickType(StudyAdditionalSectionDto, [
    "id",
    "title",
    "description",
    "language",
    "translatedFrom",
]) {
}
export class StudyPublicInfoTranslatableFields extends PickType(StudyTranslatableFieldsWithMetadataDto, [
    "language",
    "enabled",
    ...STUDY_PUBLIC_INFO_TRANSLATABLE_KEYS,
]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
export class StudyPublicInfo extends PartialType(PickType(StudyDto, STUDY_PUBLIC_INFO_KEYS)) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty(),
    Type(() => Object, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: HealthcareOrganizationPublicProfileDto, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: ExternalResearcherOrganizationPublicProfileDto, name: UserType.EXTERNAL_RESEARCHER },
            ],
        },
    }),
    ValidateNested(),
    __metadata("design:type", Object)
], StudyPublicInfo.prototype, "addedByOrganization", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => StudyPublicInfoAdditionalSectionDto),
    __metadata("design:type", Object)
], StudyPublicInfo.prototype, "additionalSections", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => StudyPublicInfoTranslatableFields),
    __metadata("design:type", Array)
], StudyPublicInfo.prototype, "studyTranslatableFields", void 0);
export class ClinicalTrialsDotGovCoreStudyDto extends OmitType(CoreStudyDto, ["owner", "status"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
export class ClinicalTrialsDotGovStudyVersionDto extends OmitType(StudyVersionDto, [
    "consentDataResourceScopes",
    "consentDataSensitivityScopes",
    "accessData",
    "patientFriendlyTitle",
    "patientFriendlySummary",
    "compensation",
    "compensationText",
    "risksOfEnrollment",
    "benefitsOfEnrollment",
    "alternativeProceduresAndTreatments",
    "futureUseOfDataEnabled",
    "futureUseOfData",
    "futureUseOfDataText",
    "rightToBeContactedByResearcher",
    "require21CFRPart11ForInformedConsents",
    "hipaaAuthorizationFormUrl",
    "hipaaAuthorizationTemplateEnabled",
    "hipaaAuthorizationText",
    "proceduresAndInterventionsText",
    "timelineVisitsEnabled",
    "timelineVisits",
    "confidentialityOfDataText",
    "injuryProtocolText",
    "participationTerminationEnabled",
    "participationTerminationText",
    "leavingStudyEarlyEnabled",
    "leavingStudyEarlyText",
    "costOfParticipationEnabled",
    "costOfParticipationText",
    "sharingResultsEnabled",
    "sharingResultsText",
    "isSponsor",
    "importMethod",
    "visitedPages",
    "visitedSections",
    "patientMRNOnInformedConsent",
    "orgLogoUrlOnInformedConsent",
    "enrollmentTranscode",
    "previewScreenshots",
    "sitePrimaryContactName",
    "sitePrimaryContactEmail",
    "sitePrimaryContactPhone",
    "sitePrimaryContactPhoneExt",
    "sitePrimaryContactTitle",
    "informedConsentSectionLocked",
    "informedConsentLockSessionId",
    "purposeOfResearchEnabled",
    "informedConsentPrimaryDiseaseOrConditions",
    "informedConsentIRBApprovalStamp",
    "informedConsentStartDate",
    "informedConsentCompletionDate",
    "informedTargetNumberOfPatients",
    "alternativesToParticipation",
    "informedConsentInterested",
    "studyVersionId",
    "versionStatus",
    "informedConsentPrimaryDiseaseOrConditionsCopied",
    "informedConsentStartDateCopied",
    "informedConsentCompletionDateCopied",
    "informedTargetNumberOfPatientsCopied",
    "lengthOfStudyEnabled",
    "injuryProtocolEnabled",
    "interventionsEnabled",
    "confidentialityMeasuresEnabled",
    "patientMRNOnParticipantSignature",
    "minorParticipantConsentEnabled",
    "additionalParentGuardianEnabled",
    "additionalParentGuardianExemptSignature",
    "minorParticipantExemptFromAssent",
    "larConsentEnabled",
    "larParticipantConsentExemptFromAssent",
    "projectType",
    "projectColor",
    "projectIcon",
    "originalStudyProtocolUrl",
    "originalInformedConsentDocumentUrl",
    "suppressNotifications",
    "organizationIconUrl",
]) {
}
export class ClinicalTrialsDotGovStudyDto extends IntersectionType(ClinicalTrialsDotGovCoreStudyDto, ClinicalTrialsDotGovStudyVersionDto) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
export class StudyUserSearchInput {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudyUserSearchInput.prototype, "userId", void 0);
export class BaseStudySearchInput {
}
__decorate([
    ApiPropertyOptional({ enumName: "StudyType" }),
    IsEnum(StudyType),
    IsOptional(),
    __metadata("design:type", String)
], BaseStudySearchInput.prototype, "studyType", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BaseStudySearchInput.prototype, "clinicalTrialPhase", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true, enumName: "StudyStatus" }),
    IsEnum(StudyStatus, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], BaseStudySearchInput.prototype, "statuses", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], BaseStudySearchInput.prototype, "paused", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true, enumName: "StudyStatus" }),
    IsEnum(StudyStatus, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], BaseStudySearchInput.prototype, "excludeStatuses", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true, type: String }),
    IsString(),
    IsOptional(),
    __metadata("design:type", Array)
], BaseStudySearchInput.prototype, "primaryDiseaseOrConditions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BaseStudySearchInput.prototype, "text", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BaseStudySearchInput.prototype, "addedByOrganizationId", void 0);
__decorate([
    ApiPropertyOptional(),
    Type(() => StudyUserSearchInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", StudyUserSearchInput)
], BaseStudySearchInput.prototype, "hasUser", void 0);
__decorate([
    ApiPropertyOptional(),
    Type(() => StudyUserSearchInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", StudyUserSearchInput)
], BaseStudySearchInput.prototype, "excludeHasUser", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], BaseStudySearchInput.prototype, "isSponsor", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], BaseStudySearchInput.prototype, "excludePaused", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], BaseStudySearchInput.prototype, "excludeDeId", void 0);
__decorate([
    ApiPropertyOptional({ enum: StudyInvestigationType, enumName: "StudyInvestigationType" }),
    IsEnum(StudyInvestigationType),
    IsOptional(),
    __metadata("design:type", Object)
], BaseStudySearchInput.prototype, "investigationType", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], BaseStudySearchInput.prototype, "includeAgentSyncStudyUsers", void 0);
__decorate([
    IsEnum(StudyPatientConsentStatusSearch),
    IsOptional(),
    __metadata("design:type", String)
], BaseStudySearchInput.prototype, "patientConsentStatusSearch", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BaseStudySearchInput.prototype, "patientId", void 0);
export class StudySearchInput extends BaseStudySearchInput {
}
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudySearchInput.prototype, "participatingPatientId", void 0);
__decorate([
    ApiPropertyOptional({ enum: ProjectType, enumName: "ProjectType", isArray: true }),
    IsEnum(ProjectType, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudySearchInput.prototype, "projectTypes", void 0);
export class FeaturedStudyDto extends StudyDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => AccessRecord),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", Object)
], FeaturedStudyDto.prototype, "accessRecord", void 0);
export class CreateStudyInput extends IntersectionType(OmitType(CoreStudyDto, ["id", "addedByOrganization", "owner", "status"]), OmitType(StudyVersionDto, [
    "studyVersionId",
    "versionStatus",
    "visitedPages",
    "visitedSections",
    "additionalSections",
    "isCompletionDateExpired",
]), OmitType(StudyTranslatableFieldsDto, [])) {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateStudyInput.prototype, "ownerId", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => CreateStudyAdditionalSectionInput,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], CreateStudyInput.prototype, "additionalSections", void 0);
__decorate([
    IsObject({ each: true }),
    ApiPropertyOptional({ isArray: true, type: StudyTranslatableFieldsWithMetadataDto }),
    IsOptional(),
    __metadata("design:type", Array)
], CreateStudyInput.prototype, "studyTranslatableFields", void 0);
__decorate([
    IsObject({ each: true }),
    ApiPropertyOptional({ isArray: true, type: StudyICFTextSegmentDto }),
    IsOptional(),
    __metadata("design:type", Array)
], CreateStudyInput.prototype, "icfTextSegments", void 0);
export class UpdateStudyCommonInput {
}
__decorate([
    ApiPropertyOptional({ isArray: true }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateStudyCommonInput.prototype, "addVisitedPages", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateStudyCommonInput.prototype, "addVisitedSections", void 0);
export class UpdateStudyInputBaseStudy extends PartialType(StudyDto) {
}
export class UpdateStudyInput extends PartialType(OmitType(CoreStudyDto, ["id", "addedByOrganization", "owner"])) {
}
export class UpdateStudyVersionInput extends IntersectionType(PartialType(OmitType(CreateStudyInput, ["additionalSections", "studyTranslatableFields", "studySectionImages", "icfTextSegments"])), PartialType(PickType(CoreStudyDto, ["status"])), PartialType(PickType(StudyVersionDto, ["versionStatus"])), UpdateStudyCommonInput) {
}
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateStudyVersionInput.prototype, "lastActivityUserId", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateStudyVersionInput.prototype, "deletePrescreenTranscode", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateStudyVersionInput.prototype, "deleteEnrollmentTranscode", void 0);
__decorate([
    ApiPropertyOptional(),
    Type(() => UpdateStudyInputBaseStudy),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", UpdateStudyInputBaseStudy)
], UpdateStudyVersionInput.prototype, "baseStudy", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => UpdateStudyAdditionalSectionInput,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateStudyVersionInput.prototype, "additionalSections", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => UpdateStudySectionImageInput,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateStudyVersionInput.prototype, "studySectionImages", void 0);
__decorate([
    IsObject({ each: true }),
    ApiPropertyOptional({ isArray: true, type: StudyTranslatableFieldsWithMetadataDto }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateStudyVersionInput.prototype, "studyTranslatableFields", void 0);
__decorate([
    IsObject({ each: true }),
    ApiPropertyOptional({ isArray: true, type: StudyICFTextSegmentDto }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateStudyVersionInput.prototype, "icfTextSegments", void 0);
export class StudyConflictErrorDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => UpdateStudyInputBaseStudy),
    ValidateNested(),
    __metadata("design:type", UpdateStudyInputBaseStudy)
], StudyConflictErrorDto.prototype, "conflicts", void 0);
export class CreateStudyPatientFacingDetailsInput extends PickType(CreateStudyInput, [
    "patientFriendlyTitle",
    "patientFriendlySummary",
    "risksOfEnrollment",
    "benefitsOfEnrollment",
]) {
}
export class PatientFacingDetailsDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "patientFriendlyTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "patientFriendlySummary", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "purposeOfResearchText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "risksOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "benefitsOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "proceduresAndInterventionsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "timelineVisitsEnabled", void 0);
__decorate([
    ApiPropertyOptional({ isArray: true }),
    Type(() => StudyTimelineVisitsDto),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], PatientFacingDetailsDto.prototype, "timelineVisits", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "alternativeProceduresAndTreatments", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "injuryProtocolText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "leavingStudyEarlyEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "leavingStudyEarlyText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "participationTerminationEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "participationTerminationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "futureUseOfDataEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "futureUseOfData", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "futureUseOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "confidentialityOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "compensation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "compensationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "costOfParticipationEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "costOfParticipationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "sharingResultsEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "sharingResultsText", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => StudyAdditionalSectionDto,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], PatientFacingDetailsDto.prototype, "additionalSections", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "primaryContactName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "primaryContactTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "primaryContactEmail", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "primaryContactPhone", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "primaryContactPhoneExt", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "protocolNumber", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "patientMRNOnInformedConsent", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "orgLogoOnInformedConsent", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "hipaaAuthorizationForm", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "lastSkippedGenaiInputHash", void 0);
__decorate([
    ApiPropertyOptional({ enumName: "ICFImportMethod" }),
    IsOptional(),
    IsEnum(ICFImportMethod),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "icfImportMethod", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "icfFileName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "hipaaAuthorizationTemplateEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "hipaaAuthorizationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "sitePrimaryContactName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "sitePrimaryContactTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "sitePrimaryContactEmail", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "sitePrimaryContactPhone", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "sitePrimaryContactPhoneExt", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "lengthOfStudyEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "injuryProtocolEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "interventionsEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "confidentialityMeasuresEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "patientMRNOnParticipantSignature", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "minorParticipantConsentEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "additionalParentGuardianEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "additionalParentGuardianExemptSignature", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "minorParticipantExemptFromAssent", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "larConsentEnabled", void 0);
__decorate([
    ApiPropertyOptional(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "larParticipantConsentExemptFromAssent", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => StudySectionImageAIDto,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "studySectionImages", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => StudySectionImageAIDto,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "unmappedSectionImages", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => StudyICFTextSegmentDto,
    }),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], PatientFacingDetailsDto.prototype, "icfTextSegments", void 0);
export class StudyUserActivityDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyUserActivityDto.prototype, "studyId", void 0);
__decorate([
    IsOptional(),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], StudyUserActivityDto.prototype, "lastSeen", void 0);
export class StudyUserActivityInput extends PartialType(OmitType(StudyUserActivityDto, ["studyId"])) {
}
export class CreatePatientFacingDetailsStudyInput extends PickType(CreateStudyInput, [
    "title",
    "briefSummary",
    "description",
    "primaryDiseaseOrConditions",
    "inclusionExclusionCriteria",
]) {
}
export class PatientFacingDetailsAIInput {
}
__decorate([
    Type(() => CreatePatientFacingDetailsStudyInput),
    ValidateNested(),
    __metadata("design:type", CreatePatientFacingDetailsStudyInput)
], PatientFacingDetailsAIInput.prototype, "input", void 0);
export class GeneratePatientFacingDetailsInput extends PatientFacingDetailsAIInput {
}
__decorate([
    IsString(),
    __metadata("design:type", Object)
], GeneratePatientFacingDetailsInput.prototype, "field", void 0);
export class StudyUserDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => Object, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: ExternalResearcherUserDto, name: UserType.EXTERNAL_RESEARCHER },
                { value: HealthcareOrganizationUserDto, name: UserType.HEALTHCARE_ORGANIZATION },
            ],
        },
    }),
    ValidateNested(),
    __metadata("design:type", Object)
], StudyUserDto.prototype, "user", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyUserDto.prototype, "savedPage", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Date)
], StudyUserDto.prototype, "createdAt", void 0);
export class AgentSyncStudyUserDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AgentSyncStudyUserDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AgentSyncStudyUserDto.prototype, "studyId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AgentSyncStudyUserDto.prototype, "userId", void 0);
export class StudyUserInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyUserInput.prototype, "savedPage", void 0);
export class AIGenerationRequiredDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], AIGenerationRequiredDto.prototype, "required", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], AIGenerationRequiredDto.prototype, "currentHash", void 0);
export class StudyReminderDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyReminderDto.prototype, "studyId", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], StudyReminderDto.prototype, "enrollmentEnabled", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyReminderDto.prototype, "enrollmentEvery", void 0);
__decorate([
    IsEnum(StudyPeriodicDayAndWeekUnits),
    __metadata("design:type", String)
], StudyReminderDto.prototype, "enrollmentUnit", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyReminderDto.prototype, "enrollmentLimit", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], StudyReminderDto.prototype, "prescreenEnabled", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyReminderDto.prototype, "prescreenEvery", void 0);
__decorate([
    IsEnum(StudyPeriodicDayAndWeekUnits),
    __metadata("design:type", String)
], StudyReminderDto.prototype, "prescreenUnit", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyReminderDto.prototype, "prescreenLimit", void 0);
export class StudyReminderInput extends OmitType(StudyReminderDto, ["studyId"]) {
}
export class StudyTranslationRequestDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(StudyTranslationLanguage),
    __metadata("design:type", String)
], StudyTranslationRequestDto.prototype, "language", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => StudyTranslatableFieldsDto),
    __metadata("design:type", StudyTranslatableFieldsDto)
], StudyTranslationRequestDto.prototype, "studyTranslatableFields", void 0);
__decorate([
    IsOptional(),
    Type(() => StudyAdditionalSectionInputForTranslation),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], StudyTranslationRequestDto.prototype, "additionalSections", void 0);
__decorate([
    IsOptional(),
    Type(() => StudySectionImageDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], StudyTranslationRequestDto.prototype, "studySectionImages", void 0);
export class StudyTranslationResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(StudyTranslationLanguage),
    __metadata("design:type", String)
], StudyTranslationResponseDto.prototype, "language", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => StudyTranslatableFieldsDto),
    __metadata("design:type", StudyTranslatableFieldsDto)
], StudyTranslationResponseDto.prototype, "studyTranslatableFields", void 0);
__decorate([
    IsOptional(),
    Type(() => StudyAdditionalSectionResponse),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], StudyTranslationResponseDto.prototype, "additionalSections", void 0);
__decorate([
    IsOptional(),
    Type(() => StudySectionImageTranslationResponse),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], StudyTranslationResponseDto.prototype, "studySectionImages", void 0);
export class StudySectionImageTranslationResponse extends PickType(StudySectionImageDto, ["caption", "translatedFrom"]) {
}
